export default function initTranslationsHU() {
  const translationsHU = [
    {
      key: 'Insurance',
      value: 'Biztosítás'
    },
    {
      key: 'Initial',
      value: 'Első díj befizetése'
    },
    {
      key: 'Contract type',
      value: 'Szerződés típusa'
    },
    {
      key: 'Payment type',
      value: 'Díjfizetés típusa'
    },
    {
      key: 'Contract number',
      value: 'Szerződésszám'
    },
    {
      key: 'Continous',
      value: 'Díj befizetése'
    },
    {
      key: 'Initial',
      value: 'Első díj befizetése'
    },
    {
      key: 'HUF',
      value: 'Forint alapú'
    },
    {
      key: 'EUR',
      value: 'Euró alapú'
    },
    {
      key: 'Offer number',
      value: 'Ajánlatszám'
    },
    {
      key: 'Personal information',
      value: 'Személyes adatok'
    },
    {
      key: 'Surname',
      value: 'Vezetéknév'
    },
    {
      key: 'Forename',
      value: 'Keresztnév'
    },
    {
      key: 'Date of birth',
      value: 'Születési idő'
    },
    {
      key: 'Zahlungsdaten',
      value: 'Fizetési részletek'
    },
    {
      key: 'Nachname',
      value: 'Nachname '
    },
    {
      key: 'Vorname',
      value: 'Vorname '
    },
    {
      key: 'Geburtsdatum',
      value: 'Geburtsdatum'
    },
    {
      key: 'E-Mail',
      value: 'E-mail cím'
    },
    {
      key: 'Offer number',
      value: 'Ajánlatszám'
    },
    {
      key: 'Zahlungsreferenz laut Zahlschein',
      value: 'Zahlungsreferenz laut Zahlschein'
    },
    {
      key: 'Prämie laut Zahlschein',
      value: 'Prämie laut Zahlschein (EUR) \n Премија според уплатница'
    },
    {
      key: 'Zahlungsart',
      value: 'Fizetési mód'
    },
    {
      key: 'Kreditkarte',
      value: 'Hitelkártya'
    },
    {
      key: 'Sofortüberweisung (Debitkarte)',
      value: 'Sofortüberweisung (Debitkarte) \n Дебитна картичка'
    },
    {
      key: 'Sie werden nach Abschluss des vollständig ausgefüllten Formulars durch Klick auf den Button "Online abschließen" zur Bezahlseite weitergeleitet, um die Zahlung per Kreditkarte durchzuführen.',
      value:
        'A teljesen kitöltött űrlap kitöltése után a „Befizetés teljesítése” gombra kattintva a fizetési oldalra kerül átirányításra.'
    },
    {
      key: 'Name',
      value: 'Vezetéknév és keresztnév'
    },
    {
      key: 'Zahlungsreferenz',
      value: 'Ajánlatszám'
    },
    {
      key: 'Prämie',
      value: 'Díj'
    },
    {
      key: 'Bezahlung',
      value: 'Fizetés'
    },
    {
      key: 'Zahlweise',
      value: 'Zahlweise'
    },
    {
      key: 'Online Prämienzahlung',
      value: 'Online fizetés'
    },
    {
      key: 'Ihre Daten',
      value: 'Szerződés adatai'
    },
    {
      key: 'Bestätigung',
      value: 'Megerősítés'
    },
    {
      key: 'Weiter',
      value: 'Következő'
    },
    {
      key: 'Zahlung abschließen',
      value: 'Befizetés teljesítése'
    },
    {
      key: 'Zurück',
      value: 'Vissza'
    },
    {
      key: 'Eingabe erforderlich!',
      value: 'Kötelező mező!'
    },
    {
      key: 'Eingabewert ist keine Emailadresse!',
      value: 'A beviteli érték nem e-mail cím!'
    },
    {
      key: 'Nur Eingabe von Zahlen erlaubt!',
      value: 'Csak számok beírása megengedett!'
    },
    {
      key: 'Eingabe kein gültiges Datum',
      value: 'A bejegyzés nem érvényes dátum'
    },
    {
      key: 'Eingabe darf keine Zahlen enthalten!',
      value: 'A bejegyzés nem tartalmazhat számokat!'
    },
    {
      key: 'Eingabe muss eine Zahl mit 12 Stellen sein!',
      value: 'Eingabe muss eine Zahl mit 12 Stellen sein!'
    },
    {
      key: 'Ihr Online-Abschluss war erfolgreich.',
      value: 'Sikeres volt az online diplomád.'
    },
    {
      key: 'Sie erhalten in Kürze ein Bestätigungsmail.',
      value: 'Hamarosan kap egy megerősítő e-mailt.'
    },
    {
      key: 'Ihr Online-Abschluss war nicht erfolgreich.',
      value: 'Az online végzettsége nem volt sikeres.'
    },
    {
      key: 'Kreditkartenzahlung fehlgeschlagen',
      value: 'Hitelkártyás fizetés sikertelen'
    }
  ];

  window.reactTranslations = window.reactTranslations || [];
  window.reactTranslations.push(...translationsHU);
}
